import shopService from '../../services/shopService'
import Vue from "vue";

const state = {
    shop_loading: true,
    shop: null,
};

const actions = {
    getShop({commit, state}) {
        state.shop_loading = true;
        shopService.getShop()
            .then(shop => {
                state.shop_loading = false;
                document.title = shop.name;
                commit('setShop', shop)
            })
            .catch(error => {
                Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о сайте.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail || "Без описания."}</div>`, {
                    type: 'error',
                    position: 'bottom-center',
                    action: {
                        text: 'Ок',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    },
                });
                document.title = "Сайт не найден";
            })
    },
    editShop({commit}, shop) {
        return new Promise((resolve, reject) => {
            shopService.editShop(shop)
                .then(shop => {
                    commit('setShop', shop)
                    resolve()
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить информацию о сайте.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail || "Без описания."}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
    setToken({commit}, data) {
        return new Promise((resolve, reject) => {
            shopService.setToken(data)
                .then((shop) => {
                    commit('setShop', shop)
                    resolve()
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить информацию о сайте.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail || "Без описания."}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                })
        })
    },
};

const mutations = {
    setShop(state, shop) {
        state.shop = shop
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}